import Vue from "vue";

export const usersService = {
  list,
  getById,
  create,
  update,
  destroy,
  getAccessLogsById
};

function list(params) {
  return Vue.axios.get("v2/admin/users", { params });
}

function getById(id) {
  return Vue.axios.get(`v2/admin/users/${id}`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("email", payload.email);
  formData.set("phone_number", payload.phone_number);
  formData.set("role", payload.role);

  if (payload.region_ids) {
    payload.region_ids.forEach(region_id => {
      formData.append("region_ids[]", region_id);
    });
  }

  if (payload.state_agency_ids) {
    payload.state_agency_ids.forEach(id => {
      formData.append("state_agency_ids[]", id);
    });
  }

  return Vue.axios.post("v2/admin/users", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function update(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("email", payload.email);
  formData.set("phone_number", payload.phone_number);
  formData.set("role", payload.role);

  if (payload.region_ids) {
    payload.region_ids.forEach(region_id => {
      formData.append("region_ids[]", region_id);
    });
  }

  if (payload.role == "presale" && payload.building_ids) {
    payload.building_ids.forEach(building_id => {
      formData.append("building_ids[]", building_id);
    });
  }

  if (payload.role == "marketing" && payload.building_ids) {
    payload.building_ids.forEach(building_id => {
      formData.append("enterprise_ids[]", building_id);
    });
  }

  if (
    payload.role == "state_agency_regional_manager" &&
    payload.state_agency_ids
  ) {
    payload.state_agency_ids.forEach(id => {
      formData.append("state_agency_ids[]", id);
    });
  }

  return Vue.axios.patch(`v2/admin/users/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function destroy(userId) {
  return Vue.axios.delete(`v1/users/${userId}`);
}

function getAccessLogsById(payload) {
  const params = {
    start_date: payload.start_date,
    end_date: payload.end_date,
    page: payload.page,
    items: payload.items
  };

  return Vue.axios.get(`v2/admin/users/${payload.user_id}/access_logs`, {
    params
  });
}
